<template>
  <b-select
    :value="localValue"
    @input="value => $emit('input', value)"
    :expanded="expanded"
    :loading="categories.loading"
  >
    <option
      v-for="category in categories.data"
      :key="category.id"
      :value="category.id"
    >{{ category.title }}</option>
  </b-select>
</template>

<script>
export default {
  props: ["value", "expanded"],

  data() {
    return {
      categories: new window.RemoteCollection("/admin/api/magazine/categories"),

      localValue: this.value
    };
  },

  created() {
    this.categories.load();
  },

  watch: {
    value() {
      this.localValue = this.value;
    }
  }
};
</script>
